module.exports = __webpack_public_path__ + "static/media/digita-logo-hybriditv-dark.067a51d7.svg";